var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragonesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 263.66,
    height: 59.272,
    style: {
      clipRule: "evenodd",
      fillRule: "evenodd",
      imageRendering: "optimizeQuality",
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision"
    },
    viewBox: "0 0 6976 1568.223",
    id: "svg42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style2"
  }, ".fil0{fill:#373435;fill-rule:nonzero}"))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1",
    transform: "translate(-639 -5194.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M7011 6044c73 37 171 59 273 59 169 0 331-69 331-243 0-274-403-207-403-350 0-60 62-86 137-86 70 0 156 19 217 52l23-128c-66-37-164-60-261-60-154 0-301 67-301 235 0 277 402 217 402 354 0 62-73 89-161 89-77 0-167-17-234-52z",
    id: "path7",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    id: "polygon9",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "M6833 5957h-580v133h580z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    id: "polygon11",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "M6833 5301h-580v132h580z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    id: "polygon13",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "M6784 5609h-531v129h531z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    id: "polygon15",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "M5810 6090h184v-789h-182v514l-321-514h-185v789h182v-514z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3511 5696c0-184 125-279 271-279 79 0 160 22 202 47l22-130c-48-26-135-49-241-49-240 0-447 128-447 411 0 284 212 412 455 412 133 0 213-31 259-59v-380h-166v293c-18 7-47 13-74 13-151 0-281-92-281-279z",
    id: "path17",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M2996 6090h186l-301-789h-234l-300 789h185l70-183h325zm-232-621 118 313h-237z",
    id: "path19",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M1540 5301v132h317c104 0 142 47 142 117s-38 117-142 117h-317v423h182v-298h127l183 298h193l-205-314c115-34 163-118 163-226 0-144-79-249-286-249z",
    id: "path21",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M639 6090h261c250 0 432-110 432-395 0-284-182-394-432-394H639Zm503-395c0 187-98 262-242 262h-79v-524h79c144 0 242 75 242 262z",
    id: "path23",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "m1764 6650 65-7c4 22 12 38 24 48s28 15 48 15c21 0 37-4 48-13s16-20 16-32c0-8-2-14-7-20-4-5-12-10-23-14-8-3-26-7-53-14-36-9-61-20-75-33-20-18-30-40-30-67 0-16 4-32 14-47 9-14 23-26 41-33 18-8 39-12 64-12 42 0 73 9 93 28 21 18 32 42 33 73l-66 2c-3-17-9-29-19-36-9-8-23-12-41-12-20 0-35 4-45 12-7 6-11 12-11 21 0 8 3 14 10 20 8 7 29 14 61 22s56 16 71 24c16 8 28 19 37 33 8 15 13 32 13 53 0 19-5 36-16 53-10 16-25 29-44 37s-43 12-72 12c-42 0-74-10-96-29s-35-47-40-84z",
    id: "path25",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil0",
    d: "M2377 6594c0-34 5-62 15-85 8-16 18-32 31-45s27-23 42-30c21-8 45-13 72-13 48 0 87 15 116 46 29 30 44 72 44 125 0 54-15 95-44 125-28 31-67 46-116 46s-88-15-116-45c-29-30-44-72-44-124zm69-2c0 37 8 65 26 85 17 19 39 29 65 29 27 0 49-10 66-29s25-48 25-86-8-66-25-85c-16-18-38-28-66-28-27 0-49 10-66 29-17 18-25 47-25 85z",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    className: "fil0",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "M3277 6483h-159v78h138v56h-138v140h-67v-330h226z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    className: "fil0",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "M3611 6427h261v56h-97v274h-66v-274h-98z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    className: "fil0",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "m4303 6653 61-226h79l57 230 50-230h67l-79 330h-71l-65-247-66 247h-73l-77-330h68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    className: "fil0",
    d: "M5226 6757h-72l-28-75h-132l-28 75h-70l128-330h70zm-122-131-46-122-44 122z",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    className: "fil0",
    d: "M5564 6757v-330h140c35 0 61 3 77 9s28 17 38 32 14 32 14 52c0 24-7 45-21 61-15 16-36 26-65 30 14 9 26 18 35 28 10 10 22 28 38 53l40 65h-79l-48-72c-17-26-29-42-35-49-6-6-13-11-20-13-7-3-19-4-34-4h-13v138zm67-190h49c32 0 52-2 60-4 7-3 14-8 18-14 5-7 7-15 7-25 0-11-3-20-9-27s-14-11-25-13c-5-1-22-1-48-1h-52z",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: 7,
    className: "fil0",
    style: {
      fill: "#373435",
      fillRule: "nonzero"
    },
    d: "M6442 6483h-177v73h165v56h-165v89h184v56h-250v-330h243z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_893310688"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5044 5582c32 76 33 163-3 241-11 22-23 43-38 61-21 26-47 47-75 64-85 52-197 61-297 15-94-44-157-127-177-219-19 141 58 286 199 352 86 40 179 43 261 15 81-28 150-86 188-169 46-97 37-207-13-296-13-23-28-44-45-64z",
    id: "path34",
    style: {
      fill: "#088fd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4917 5851c20-18 37-40 49-65 12-27 18-55 18-84-1-47-19-93-50-129-9-6-18-11-27-15-42-20-87-24-129-16 59 34 93 96 90 159-1 22-6 43-15 64-14 30-36 54-63 70-36 23-81 32-125 24 1 1 2 3 4 4 8 6 17 11 26 15 77 36 163 22 222-27z",
    id: "path36",
    style: {
      fill: "#5cceeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4307 5514c-107 228 0 503 238 614 1 0 1 1 2 1-156-114-218-320-136-495 27-58 81-121 129-165l-9 18s0 1-1 1c-17 37-24 77-21 116 1 16 4 32 9 47 12 44 36 84 71 116-25-62-14-130 14-189 9-20 21-38 35-54 15-18 32-33 51-45 2-2 5-4 8-5 37-23 81-36 126-37-4 3-7 6-11 9-5 4-9 9-15 16s-12 16-16 23-5 12-4 13c1 2 3 2 9-2 5-4 14-10 24-16s21-12 33-17c45-17 89-19 127 15-21-35-46-36-36-63 2-6 4-13 4-19s-2-11-3-13c-1-3-1-3-2-2 0 1-1 3-3 5-1 3-3 5-5 7s-3 3-6 4c-3 0-7 1-11 0-5 0-10-2-13-3s-4-2-5-3c-1-2-2-4-3-4-1-1-1-1-3 0-3 2-8 5-11 7s-4 3-7 2c-4 0-11-2-16-3s-9-2-14-3c-4-1-10-3-14-5s-7-4-9-6c-3-2-5-2-7-3h-4c0-1 1-3 3-5s5-4 9-5c3-1 8-3 13-2 5 0 11 3 16 5 4 2 8 5 12 5 3 1 5-1 8-3 4-3 8-7 14-10 5-2 13-4 20-5 8-1 15-1 24 0 9 2 18 4 26 9 8 4 14 11 19 18 4 7 7 15 8 19 2 4 2 4 3 3 1-2 2-5 3-8 1-4 2-7 2-11v-11c0-3 1-4 1-5s1-1 2-2c0-1 1-2 0-8 0-7-2-19-5-28-2-9-6-15-9-20-4-5-7-9-11-12-4-4-9-7-11-9-3-1-3-2-5-3-2 0-5-1-8-1-4 0-8 2-21 2-14 1-35 0-46 0s-12 0-13-1c-2-1-5-4-8-5-2-2-3-2-10-3-6 0-19-1-35-2-15-1-35-1-45-2-10 0-11 0-15-2-5-1-12-5-23-10-10-5-23-11-32-14s-13-2-19 0c-5 2-11 4-16 6-3 1-6 1-27 3-3-1-7-2-11-3-30-6-86-13-139-20-2-2-5-4-7-6-11-9-22-19-28-25-7-6-9-8-12-9-4-1-7-1-10-1s-5-1-4 1 4 6 11 14c5 6 11 14 16 21-39-5-74-9-97-12-29-3-39-3-48-3-8-1-14-1-18 0-4 2-6 5-9 7-2 3-4 6-3 9 0 2 4 4 46 14 39 10 110 26 160 37-19 0-38 1-56 2-53 3-102 6-132 9-29 2-39 4-47 5-9 1-15 2-18 4-4 2-6 6-8 9-1 3-3 6-2 8 1 3 5 4 49 6 28 2 73 3 115 5-13 6-32 15-45 21-15 8-23 12-25 14-3 1-1 1 3 1s9 0 15-1 14-3 26-7 29-10 49-16c12-4 25-7 35-11h4c7 0 14 1 20 1 1 1 1 3 2 4h-1c-63 43-116 103-150 177zm371-203c7-2 20-5 31-7 10-2 17-2 21-3 4 0 5-1 5-3-1-1-2-3-6-4-3-1-9-2-18-2-9-1-22-2-29-2-8 1-9 2-11 5-1 4-2 10-3 13 0 3 0 4 1 4s2 0 9-1z",
    id: "path38",
    style: {
      fill: "#0566b6"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragonesLogo);
export default __webpack_public_path__ + "static/media/DragonesLogo.3a95461189da4102b269ecb5d3528baa.svg";
export { ForwardRef as ReactComponent };